import { createContext, useContext, useState } from "react";
import { ShoppingBag, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { business } from "../data/site";

const OrderContext = createContext(() => {});
export const useOrder = () => useContext(OrderContext);

export function OrderProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openOrder = () => setOpen(true);

  return (
    <OrderContext.Provider value={openOrder}>
      {children}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="order-dialog"
          className="bg-[#141414] border-white/10 text-white max-w-md p-7 rounded-2xl"
        >
          <DialogHeader>
            <DialogTitle className="font-display text-3xl font-bold text-white text-left">
              Order Online
            </DialogTitle>
            <p className="text-neutral-400 text-base text-left mt-1">Choose how you&apos;d like to get your food.</p>
          </DialogHeader>

          <div className="mt-4 space-y-3">
            {/* Uber Eats */}
            <a
              href={business.orderUberEats}
              target="_blank"
              rel="noreferrer"
              data-testid="order-ubereats"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-4 bg-white rounded-xl px-5 py-4 hover:opacity-90 transition-opacity"
            >
              <span className="font-bold text-xl">
                <span className="text-[#0a0a0a]">Uber </span>
                <span className="text-[#06C167]">Eats</span>
              </span>
              <span className="flex items-center gap-2 text-neutral-500 text-sm font-semibold">Delivery + Pickup <ChevronRight size={18} /></span>
            </a>

            {/* SkipTheDishes */}
            <a
              href={business.orderSkip}
              target="_blank"
              rel="noreferrer"
              data-testid="order-skip"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-4 bg-white rounded-xl px-5 py-4 hover:opacity-90 transition-opacity"
            >
              <span className="font-extrabold text-xl tracking-tight">
                <span className="text-[#FF6B00]">Skip</span>
                <span className="text-[#0a0a0a]">TheDishes</span>
              </span>
              <span className="flex items-center gap-2 text-neutral-500 text-sm font-semibold">Delivery + Pickup <ChevronRight size={18} /></span>
            </a>

            {/* In-House (pickup only) */}
            <a
              href={business.orderInHouse}
              target="_blank"
              rel="noreferrer"
              data-testid="order-inhouse"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-4 bg-[#ffd100] rounded-xl px-5 py-4 hover:bg-[#e5bc00] transition-colors"
            >
              <span className="flex items-center gap-3 text-[#0a0a0a]">
                <ShoppingBag size={22} strokeWidth={2.4} />
                <span className="font-bold text-xl">Order Direct</span>
              </span>
              <span className="flex items-center gap-2 text-[#0a0a0a]/70 text-sm font-bold uppercase tracking-wide">Pickup only <ChevronRight size={18} /></span>
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </OrderContext.Provider>
  );
}
